<template>
    <div v-if="$can('create-relations-addresses')
            || $can('update-relations-addresses')
            || $can('view-relations-addresses')
            || $can('delete-relations-addresses')"
    >
        <div class="row addresses-show-area" v-if="$can('view-relations-addresses')">
            <div class="col-12 mb-2" v-if="$can('create-relations-addresses') && !showOnly">
                <a class="btn btn-brand"
                   @click.prevent="createAddress">{{ uLang('app.add_type', {type: lang('app.address')}) }}</a>
            </div>

            <div class="col-md-12 add-row">
                <p v-if="componentAddresses.length == 0">{{ uLang('app.no_address_found') }}</p>
            </div>
            <div class="col-xl-4 col-lg-6 item" v-for="address of componentAddresses">
                <address-card
                    :showOnly="showOnly"
                    :address="address"
                    :editAddress="editAddress"
                    :deleteAddress="deleteAddress"
                    :duplicateAddress="duplicateAddress"
                />
            </div>
        </div>

        <b-modal
            id="add_addressModal"
            :hideFooter="true"
            :title="modalTitle"
            ref="addressModal"
            size="md"
            v-if="($can('create-relations-addresses') || $can('update-relations-addresses')) && !showOnly"
        >
            <form-address
                :override-endpoint="overrideEndpoint"
                :key="addressId"
                @addressUpdated="updateAddress"
                @addressStored="addAddress"
                :id="addressId"
                ref="addressForm"
            />
        </b-modal>
    </div>
</template>
<script>
    import DestroyAlert from '~/Swals/DestroyAlert'
    import pluralize from 'pluralize'
    import { ConfirmationAlert } from "~/Swals";

    export default {
        name: 'addresses-display',

        props: {
            entity: {
                type: String,
                required: true,
            },
            id: {
                required: true,
            },
            addresses: {
                type: Array,
                required: true,
            },
            showOnly: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                componentAddresses: [],
                modalTitle: null,
                addressId: null,
            }
        },

        created() {
            this.componentAddresses = this.addresses;
        },

        methods: {
            createAddress() {
                this.modalTitle = this.uLang('app.add_type', { type: this.uLang('app.address')});
                this.addressId = null;
                this.$refs.addressForm.form.reset()
                this.$refs.addressModal.show();
            },

            duplicateAddress(address) {
                new ConfirmationAlert({
                    text: this.uLang('app.duplicate_type', { type: this.lang('app.address') })
                })
                    .show()
                    .then(async () => {
                        const { data } = await window.axios.post(route('addresses.duplicate', {
                            address: address.id
                        }));

                        this.addAddress(data);
                    })
            },

            editAddress(address) {
                this.modalTitle = this.uLang('app.edit_type', { type: this.lang('app.address')});
                this.addressId = address.id;
                this.$refs.addressForm.form.reset()
                this.$nextTick(() => {
                    this.$refs.addressForm.retrieve()
                    this.$refs.addressModal.show();
                });
            },

            updateAddress(address) {
                this.$refs.addressModal.hide();
                this.updateComponentAddress(address);
            },

            addAddress(address) {
                this.$refs.addressModal.hide();
                this.componentAddresses.push(address);
            },

            updateComponentAddress(updatedAddress) {
                this.componentAddresses = this.componentAddresses.map((address) => {
                    if(address.id == updatedAddress.id) {
                        return updatedAddress;
                    }

                    return address;
                });
            },

            removeAddress(address) {
                let id = address.id;

                this.componentAddresses = this.componentAddresses.filter((address) => {
                    return address.id != id;
                });
            },

            async deleteAddress(address) {
                new DestroyAlert({ entity: this.lang('app.address') }).show().then(async () => {
                    const { data } = await window.axios.delete(route(pluralize(this.entity) + '.addresses.destroy', { [this.entity]: this.id, address: address.id }));
                    this.removeAddress(data);
                })
            },
        },

        computed: {
            overrideEndpoint() {
                return route(pluralize(this.entity) + '.addresses.store', { [this.entity]: this.id })
            }
        }
    }
</script>
<style lang="scss">
</style>
